import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { 
  GetAdminDashboardDataAction,
  GetAdminAnalyticsAction,
} from "../../Actions/adminActions";
import {
  setDashboardData,
  setAnalytics,
  setLoading,
  setError,
  clearError,
  updateMetrics,
  addRecentActivity,
} from "../../Reducers/Admin/adminDashboardReducer";
import {
  getAdminDashboardData,
  getAdminAnalytics,
} from "../../../services/adminDashboardService";

// Get Admin Dashboard Data Saga
function* getAdminDashboardDataSaga(action) {
  try {
    console.log("run getAdminDashboardDataSaga ")
    yield put(setLoading(true));
    yield put(clearError());
    const response = yield call(getAdminDashboardData, action.payload);
console.log("response------------------",response)
    if (response?.ok) {
      const data = response.data?.data || {};
      // Persist entire payload for charts/activities usage
      yield put(setDashboardData(data));
      // Map metrics to existing reducer fields
      yield put(
        updateMetrics({
          totalUsers: data.totalUsers || 0,
          // reuse totalSubscriptions to reflect active subscriptions metric
          totalSubscriptions: data.activeSubscriptions || 0,
          apiUsage: data.totalApiUsage || 0,
        })
      );
    } else {
      yield put(setError(response?.data?.message || response?.problem || "Failed to fetch dashboard data"));
    }
  } catch (error) {
    yield put(setError(error?.message || "Failed to fetch dashboard data"));
  } finally {
    yield put(setLoading(false));
  }
}

// Get Admin Analytics Saga
function* getAdminAnalyticsSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(getAdminAnalytics, action.payload);
    
    if (response.success) {
      yield put(setAnalytics(response.data));
    } else {
      yield put(setError(response.message || "Failed to fetch analytics data"));
    }
  } catch (error) {
    yield put(setError(error.message || "Failed to fetch analytics data"));
  } finally {
    yield put(setLoading(false));
  }
}

// Watcher Sagas
export function* watchGetAdminDashboardData() {
  yield takeLatest(GetAdminDashboardDataAction.type, getAdminDashboardDataSaga);
}

export function* watchGetAdminAnalytics() {
  yield takeLatest(GetAdminAnalyticsAction.type, getAdminAnalyticsSaga);
}
